import { BellTwoTone } from '@ant-design/icons';
import { ConfigProvider, Modal } from 'antd';
import mnMN from 'antd/lib/locale/mn_MN';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.less';
import AppRoutes from './AppRoutes';
import ErrorBoundary from './components/common/ErrorBoundary';
import message from './components/message';
import useStore from './store/useStore';
import { ERR_STATUS_CODES, toUserMessage } from './utils/apiError';

let requestInterceptor = null;
let responseInterceptor = null;
const TOASTER_DURATION = 10;

const queryClient = new QueryClient();

/**
 * Бүтэн дэлгэцийн loading overlay-г зориудаар ашиглахгүй — хуудас бүр
 * (хүснэгт, товч) өөрийн loading-тай тул давхар loading харагддаг байв.
 */
const App = () => {
  const token = useStore((state) => state.token);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [popupData, setPopupData] = useState({});

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  if (!!requestInterceptor || requestInterceptor === 0) {
    axios.interceptors.request.eject(requestInterceptor);
  }

  if (!!responseInterceptor || responseInterceptor === 0) {
    axios.interceptors.response.eject(responseInterceptor);
  }

  requestInterceptor = axios.interceptors.request.use((config) => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    config.headers = {
      'Content-Type': 'application/json',
      ...config.headers,
    };

    if (!config.noAuthorization && !config.headers.Authorization) {
      config.headers.Authorization = token;
    }

    if (!config.url.startsWith('http')) {
      config.url = `${BASE_URL}${config.url}`;
    }

    return config;
  });

  const logout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/';
  };

  const getPromo = async () => {
    const body = {
      type: 'web',
    };

    // Сурталчилгааг session-д нэг л удаа харуулна — refresh бүрт гарахгүй
    if (sessionStorage.getItem('isModalShown')) return;

    try {
      // Сурталчилгаа ачаалагдаагүй нь хэрэглэгчид мэдэгдэх алдаа биш
      const popUp = await axios.post('/api/v1/notification/popup', body, {
        skipErrorToast: true,
      });
      if (popUp?.data?.result) {
        setPopupData(popUp.data.result);
        setIsModalOpen(true);
        sessionStorage.setItem('isModalShown', true);
      }
    } catch (e) {
      console.error('Promo popup error: ', e);
    }
  };

  useEffect(() => {
    if (token !== null) {
      getPromo();
    }
  }, [token]);

  responseInterceptor = axios.interceptors.response.use(
    (res) => {
      if (ERR_STATUS_CODES.includes(res?.data?.statusCode) && !res?.config?.skipErrorToast) {
        // Сервер дотоод алдаагаа (Mongoose валидац, JS TypeError) шууд буцаадаг
        // тул `toUserMessage` түүнийг шүүж, зөвхөн монгол шалтгааныг харуулна
        message(toUserMessage(res?.data), false, { duration: TOASTER_DURATION });
      }
      return res;
    },
    (error) => {
      /**
       * Зөвхөн нэвтэрсэн хэрэглэгчийн session дууссан үед гаргана. Нэвтрэх
       * хуудсанд (token байхгүй) 401 ирвэл хуудсыг reload хийлгүй, алдааг
       * дуудлагын газар харуулна.
       */
      if (error?.response?.status === 401 && token) {
        logout();
      } else if (!error?.config?.skipErrorToast) {
        /**
         * HTTP 500 дээр сервер дотоод JS алдааны текстээ буцаадаг тул шүүнэ.
         * `skipErrorToast` — дуудлагын газар өөрөө илүү тодорхой мессеж
         * харуулах бол хоёр toast давхардахаас сэргийлнэ.
         */
        message(toUserMessage(error?.response?.data), false, {
          duration: TOASTER_DURATION,
        });
      }
      return Promise.reject(error);
    }
  );

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        locale={mnMN}
        theme={{
          token: {
            colorPrimary: '#2FA1D9',
            colorLink: '#2FA1D9',
            borderRadius: 8,
          },
          components: {
            Steps: {
              descriptionMaxWidth: '250px',
            },
            Select: {
              fontSizeLG: '14px',
            },
            Button: {
              fontSizeLG: '14px',
              fontWeight: 500,
            },
            Input: {
              fontSizeLG: '14px',
              //inputFontSize: '12px'
            },
          },
        }}
      >
        <Router>
          <ErrorBoundary>
            <AppRoutes />
          </ErrorBoundary>
          <Modal
            title={
              <div>
                <p style={{ fontWeight: 600 }}>
                  <BellTwoTone style={{ fontSize: '18px', color: '#08c' }} />
                  {` ${popupData?.title}`}
                </p>
              </div>
            }
            open={isModalOpen}
            onCancel={handleCancel}
            footer={null}
          >
            <img src={popupData?.url} alt="" width={460} height={270} />
          </Modal>
        </Router>
      </ConfigProvider>
    </QueryClientProvider>
  );
};

export default App;
